import { render, staticRenderFns } from "./ManagerContractsFolder.vue?vue&type=template&id=60012b4c&scoped=true"
import script from "./ManagerContractsFolder.vue?vue&type=script&lang=js"
export * from "./ManagerContractsFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60012b4c",
  null
  
)

export default component.exports